import type { ImageSourcePropType } from 'react-native';

// Vite imports assets as URLs; Metro imports them as native asset references.
export const imageSource = (
  asset: string | ImageSourcePropType,
): ImageSourcePropType => (typeof asset === 'string' ? { uri: asset } : asset);
